import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function getAllCrewEmployeesApi(query) {
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees,
    method: 'get',
    query
  }));
}

export function getAllCrewEmployeesWithoutPaginationApi(query) {
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + endpoints.all,
    method: 'get',
    query
  }));
}
export function addNewCrewEmployeeApi(payload) {
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees,
    method: 'post',
    payload: payload
  }));
}

export function editCrewEmployeeApi(payload) {
  if (payload?.employeeId) {
    return (apiRequest({
      url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + `/${payload.employeeId}`,
      method: 'put',
      payload: payload
    }));
  }
}

export function editSupervisor() {

}

export function deleteCrewEmployeeApi(id) {
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + `/${id}`,
    method: 'delete'
  }));
}

export function downloadCrewMembersApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + endpoints.bulk + endpoints.download,
    method: 'get',
    query,
    responseType: 'arraybuffer'
  });
}

export function addManualAttendnaceApi(payload) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.crewEmployees + endpoints.attendance,
    method: 'put',
    payload
  })
}